const getErrorMessage = (messages, defaultMessage) => {

  if (!messages) {
    return [defaultMessage]
  } else if (typeof messages === 'string') {
    return [messages]
  }

  return [...messages]

}

export default getErrorMessage
